/**
 * Shared display constants for Live Trade Execution & Order Management
 * (Phase 4). Mirrors backend `StrategyExecutionStatus`/`OrderState`.
 */
import type { BrokerOrderState, StrategyExecutionStatus } from "@/types";

export const STRATEGY_STATUS_LABELS: Record<StrategyExecutionStatus, string> = {
  READY: "READY",
  SUBMITTING: "SUBMITTING…",
  PARTIALLY_EXECUTED: "PARTIALLY EXECUTED",
  FULLY_EXECUTED: "FULLY EXECUTED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
  REQUIRES_ATTENTION: "REQUIRES ATTENTION",
};

export const STRATEGY_STATUS_COLORS: Record<StrategyExecutionStatus, "success" | "warning" | "error" | "info" | "default"> = {
  READY: "default",
  SUBMITTING: "info",
  PARTIALLY_EXECUTED: "warning",
  FULLY_EXECUTED: "success",
  FAILED: "error",
  CANCELLED: "default",
  REQUIRES_ATTENTION: "error",
};

export const ORDER_STATE_LABELS: Record<BrokerOrderState, string> = {
  PENDING: "Pending",
  OPEN: "Open",
  PARTIALLY_FILLED: "Partially Filled",
  FILLED: "Filled",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
  UNKNOWN: "Unknown",
};

export const ORDER_STATE_COLORS: Record<BrokerOrderState, "success" | "warning" | "error" | "info" | "default"> = {
  PENDING: "default",
  OPEN: "info",
  PARTIALLY_FILLED: "warning",
  FILLED: "success",
  REJECTED: "error",
  CANCELLED: "default",
  EXPIRED: "default",
  UNKNOWN: "warning",
};

/** Strategy-level terminal states — polling stops once one of these is reached. */
export const TERMINAL_STRATEGY_STATUSES: StrategyExecutionStatus[] = ["FULLY_EXECUTED", "FAILED", "CANCELLED", "REQUIRES_ATTENTION"];

export const STATUS_POLL_INTERVAL_MS = 3000;
